import { useWatch } from 'react-hook-form';
import { NumberInput, TextInput, required } from 'react-admin';

const DiscountInput = (props: any) => {
  const mrp = useWatch({ name: 'mrp' });
  const amount = useWatch({ name: 'amount' });

  const validateDiscount = (value: any) => {
    const maxValue = mrp ?? amount;

    if (value < 0) return 'Discount cannot be negative';

    if (maxValue !== undefined && parseFloat(value) > parseFloat(maxValue)) {
      return `Discount cannot be more than ${mrp !== undefined ? 'MRP' : 'Amount'}`;
    }

    return undefined;
  };

  return (
    <NumberInput
      {...props}
      type="number"
      source="discount"
      prefix="₹"
      fullWidth
      validate={[required(), validateDiscount]}
    />
  );
};

export default DiscountInput;
